import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { createTransaction } from '../database/Functions';
import { DollarSign, Wallet } from 'lucide-react';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';

/* const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = loadStripe(stripePublishableKey); */

function AddFunds() {
  const { currentUser, userProfile } = useAuth();
  const [amount, setAmount] = useState(10);
  
  // Determine PayPal client id based on mode (live or sandbox)
  const paypalMode = (process.env.REACT_APP_PAYPAL_MODE || 'live').toLowerCase();
  const paypalClientId = paypalMode === 'live'
    ? (process.env.REACT_APP_PAYPAL_LIVE_CLIENT_ID || process.env.REACT_APP_PAYPAL_CLIENT_ID)
    : (process.env.REACT_APP_PAYPAL_SANDBOX_CLIENT_ID || process.env.REACT_APP_PAYPAL_CLIENT_ID);

  /* const handleAddFunds = async (event) => {
    event.preventDefault();  // Prevents page reload
    //return;

    if (!systemSettings || systemSettings.blockAppUse === true || systemSettings.depositsAllowed === false) {
      alert("Deposits are temporarily blocked.");
      return;
    }

    if (!amount || amount <= 0) {
      alert('Please enter a valid amount.');
      return;
    }

    if (!amount || amount < 10) {
      alert('The minimum deposit amount is $10');
      return;
    }

    if (!amount || amount > 1000) {
      alert('The maximum deposit amount is $1000');
      return;
    }

    setLoading(true);

    const depositAmount = parseFloat(amount);
    const newBalance = userProfile.account_balance + depositAmount;
    
    const functions = getFunctions();
    const createStripeCheckout = httpsCallable(functions, 'createStripeCheckout');
  
    try {
      const response = await createStripeCheckout({amount, userId: currentUser.uid});
      const sessionId = response.data.id;
  
      const stripe = await stripePromise; // Wait for the stripePromise to resolve
      const result = await stripe.redirectToCheckout({ sessionId });
  
      if (result.error) {
        // Handle any errors returned by Stripe
        console.error(result.error.message);
        createTransaction(currentUser.uid, "Deposit", "Deposit Error", userProfile.account_balance, newBalance, amount, { 
          status: 'cancelled',
          amount: parseFloat(amount),
          timestamp: new Date().toISOString(),
          type: 'deposit'
        })

      }else{
        createTransaction(currentUser.uid, "Deposit", "Successful Deposit", userProfile.account_balance, newBalance, amount, { 
          status: 'successful',
          amount: parseFloat(amount),
          timestamp: new Date().toISOString(),
          type: 'deposit'
        })
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      createTransaction(currentUser.uid, "Deposit", "Deposit Error", userProfile.account_balance, newBalance, amount, { 
        status: 'cancelled',
        amount: parseFloat(amount),
        timestamp: new Date().toISOString(),
        type: 'deposit'
      })
      alert("Error during checkout:", error);
    } finally {
      setLoading(false);
    }
  }; */

  const handleCreateOrder = async () => {
    const functions = getFunctions();
    const createOrder = httpsCallable(functions, 'createPayPalOrder');
    const response = await createOrder({ amount, userId: currentUser.uid });
    return response.data.id;
  };

  

  return (
    <div className="min-h-screen">
      <h2 className="text-2xl font-bold text-white mb-6 flex items-center">
        <Wallet className="w-6 h-6 text-emerald-400 mr-2" />
        Deposit Funds
      </h2>
      
      <div className="bg-gray-900/50 backdrop-blur-sm rounded-xl border border-gray-800 p-6">
        <div className="flex flex-col md:flex-row gap-8">
          <div className="w-full md:w-2/3">
            <form className="space-y-6">
              <div>
                <label className="block text-lg font-medium text-white mb-2">Amount to Deposit</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <DollarSign className="h-5 w-5 text-gray-400" />
                  </div>
                  <input 
                    type="number" 
                    value={amount} 
                    onChange={(e) => setAmount(parseFloat(e.target.value) || '')} 
                    className="block w-full pl-12 pr-4 py-3 rounded-lg bg-gray-800/70 border border-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                    placeholder="Enter amount"
                    min="10"
                    max="1000"
                  />
                </div>
                <p className="text-sm text-gray-400 mt-2">Minimum deposit: $10 | Maximum deposit: $1000</p>
              </div>
              
              {/* Stripe elements removed */}
              
              {/* <button 
                onClick={handleAddFunds} 
                disabled={loading || !amount || amount < 10 || amount > 1000}
                className="w-full bg-emerald-500 hover:bg-emerald-600 text-white py-3 px-4 rounded-lg transition-colors font-medium flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-2"></div>
                    Processing...
                  </>
                ) : (
                  <>
                    <CreditCard className="w-5 h-5 mr-2" />
                    Add ${amount || '0.00'} to Account
                  </>
                )}
              </button> */}
              <PayPalScriptProvider options={{ "client-id": paypalClientId, "disableFunding": "paylater" }}>
                <PayPalButtons
                  createOrder={handleCreateOrder}
                  onApprove={async (data, actions) => {
                    const captureData = await actions.order.capture();
                    console.log("captureData", captureData);
                    // Record successful PayPal deposit like in AddFunds
                    try {
                      const depositAmount = parseFloat(amount);
                      const newBalance = (userProfile?.account_balance || 0) + depositAmount;
                      createTransaction(
                        currentUser.uid,
                        "Deposit",
                        "Successful Deposit",
                        userProfile.account_balance,
                        newBalance,
                        amount,
                        {
                          status: "successful",
                          amount: depositAmount,
                          timestamp: new Date().toISOString(),
                          type: "deposit"
                        }
                      );
                    } catch (e) {
                      console.error("Error recording PayPal deposit transaction", e);
                    }
                    alert("Deposit successful!");
                  }}
                />
              </PayPalScriptProvider>

              
            </form>
          </div>
          
          <div className="w-full md:w-1/3 bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700">
            <h3 className="text-lg font-medium text-white mb-4">Deposit Summary</h3>
            
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-300">Amount:</span>
                <span className="text-white font-medium">${amount || '0.00'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-300">Processing Fee:</span>
                <span className="text-white font-medium">$0.00</span>
              </div>
              <div className="border-t border-gray-700 my-2 pt-2"></div>
              <div className="flex justify-between">
                <span className="text-gray-300">Total:</span>
                <span className="text-emerald-400 font-bold">${amount || '0.00'}</span>
              </div>
            </div>
            
            <div className="mt-6 bg-gray-900/50 p-4 rounded-lg">
              <h4 className="text-sm font-medium text-white mb-2">Secure Payment</h4>
              <p className="text-xs text-gray-400">
                Your payment information is processed securely. We do not store your credit card details.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddFunds;
